import axios from "axios";

axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

export default class AdfNewsletter
{
    constructor ()
    {
        this.createClosure();
        this.bindEvents();
    }

    createClosure ()
    {
        this.fctSubmit   = this.submit.bind( this );
        this.fctKeyUp    = this.onKeyUp.bind( this );
    }

    bindEvents ()
    {
        this.frmEmail = document.querySelector( "[data-frm-newsletter-email]" );
        this.frmSubscribe = document.querySelector( "[data-frm-newsletter]" );
        this.txtEmail     = document.querySelector( "[data-txt-newsletter]" );

        if  (!this.frmSubscribe && !this.frmEmail)
        {
            return;
        }

        if (this.txtEmail)
        {
            this.txtEmail.addEventListener("keyup", this.fctKeyUp.bind(this));
        }

        if (this.frmEmail)
        {
            this.frmEmail.addEventListener("submit", this.fctSubmit.bind(this));

        }

        if (this.frmSubscribe)
        {
            this.frmSubscribe.addEventListener("submit", this.fctSubmit.bind(this));
            this.arrSpanError = Array.from(document.querySelectorAll("[data-error]"));
            this.groupNewsletter = document.querySelector("[data-group-newsletter]");
            this.groupSubscribe = document.querySelector("[data-group-subscribe]");
            this.message = document.querySelector("[data-message]");
            this.containerForm = document.querySelector(".form-box");
        }

        this.divSpinner     = document.querySelector( ".newsletter-spinner" );
        this.btnSubmit     = document.querySelector( "[data-btn-newsletter-submit]" );
    }

    onKeyUp ( e )
    {
        let code = e.code;

        if ( code === "Enter" )
        {
            this.submit( null );
        }
    }

    async submit ( e )
    {
        if ( e )
        {
            e.preventDefault();
        }

        if (this.frmSubscribe)
        {
            //this.frmSubscribe.submit();
            const form = new FormData(this.frmSubscribe);

            const datas = Object.fromEntries(form.entries());

            this.arrSpanError.forEach( spanError => spanError.classList.add( "d-none" ));
            this.divSpinner.classList.remove("d-none");
            this.btnSubmit.classList.add("d-none");

            let response = await axios.post( "/endpoints/newsletter/subscribe", datas )


            this.arrSpanError.forEach( spanError => spanError.innerText = "");

            if ( !response.data.success )
            {
                let errors = response.data.errors;

                for ( let strError in errors)
                {
                    let error = errors[strError];

                    let spanError = document.querySelector(`#error_${strError}`);

                    if (spanError && (error[0] ?? false))
                    {
                        spanError.innerText = error[0];
                        spanError.classList.remove("d-none");
                    }
                }
                // this.spanError.innerText = response.data.errors[ "email" ][ 0 ] ?? 'Une erreur est survenue';
                // this.spanError.classList.remove( "d-none" );

                this.divSpinner.classList.add("d-none");
                this.btnSubmit.classList.remove("d-none");
            } else
            {
                // this.groupNewsletter.classList.add( "d-none" );
                // this.groupSubscribe.classList.remove( "d-none" );
                this.containerForm.classList.add("d-none");
                this.divSpinner.classList.add("d-none");
                this.message.classList.remove("d-none");
            }
        }
        else
        {
            this.divSpinner.classList.remove("d-none");
            this.btnSubmit.classList.add("d-none");
            this.redirect(e);
        }
    }

    redirect ( e )
    {
        if ( e )
        {
            e.preventDefault();
        }

        this.frmEmail.submit();

    }


}
